import { render } from "./MasterDataTablePermissionForm.vue?vue&type=template&id=025d1902&ts=true"
import script from "./MasterDataTablePermissionForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataTablePermissionForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__